import { render, staticRenderFns } from "./promotionManagement.vue?vue&type=template&id=64e82a22&"
import script from "./promotionManagement.vue?vue&type=script&lang=js&"
export * from "./promotionManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports